/** Created by azhou on 2019/3/12.*/
<template>
    <div>
      <public-title>{{add ? '添加' : '编辑'}}门店
        <span class="text-link ml-auto h6" slot="right" @click="$router.push({name:'StoreBasicInfo'})">返回列表</span>
      </public-title>
      <progress-bar class="mb-5" @changeStep="changeStep"/>
      <div class="bg-white p-4">
        <!--添加门店基本信息-->
        <t-reg-basic @saveInfo="info => this.saveBasicInfo(info,2)" v-if="step===1 && storeInfo.type===2"/>
        <h-reg-basic @saveInfo="info => this.saveBasicInfo(info,2)" v-if="step===1 && storeInfo.type!==2"/>
        <!--酒店、民宿、景区的门店相册-->
        <store-photos @saveInfo="info => this.saveAlbum(info,3)" v-if="step===2 && storeInfo.type!==2"/>
        <!--酒店、民宿的房型会议室列表-->
        <room-meet-lists v-if="(step===3 || step===4) && (storeInfo.type == 3 || storeInfo.type == 5)"/>
        <!--门店提交认证页面-->
        <submit-verify v-if="showVerifyStep"/>
      </div>
    </div>
</template>
<script>
  import { mapGetters,mapState, mapActions,mapMutations } from 'vuex'
  import TRegBasic from './Comps/TRegBasic'
  import HRegBasic from './Comps/HRegBasic'
  import StorePhotos from './Comps/StorePhotos'
  import SubmitVerify from './Comps/SubmitVerify'
  import RoomMeetLists from '../RoomMeetsInfo/Comps/RoomMeetLists'
  import ProgressBar from './Comps/ProgressBar'
  export default {
    name: 'GroupAddStore',
    components:{ProgressBar,TRegBasic,HRegBasic,StorePhotos,SubmitVerify,RoomMeetLists},
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo','isGroup']),
      add () { return this.$route.query.add },
      step() { return Number(this.$route.query.step) },
      store() { return Number(this.$route.query.store) },
      showVerifyStep() {
        switch (this.storeInfo.type) {
          case 2: return this.step === 2;
          case 6: return this.step === 3;
          default: return this.step >= 5;
        }
      }
    },
    watch:{
      store(newVal) {
        if (newVal) {
          this.UPDATECURRENTSTORE({storeId:newVal});
          this.getStoreInfo();
        }
      },
      storeInfo(newVal) {
        if (newVal.verify === 2) {
          if (newVal.type == 6) this.changeStep(3)
          else this.changeStep(6);
        }else this.changeStep(this.$route.query.step || 1)
      }
    },
    created() {
      if (this.store) {
        this.UPDATECURRENTSTORE({storeId:this.store});
        this.getStoreInfo();
      }
    },
    destroyed() {
      //组件销毁时清空当前门店信息
      this.UPDATESTOREBASIC({})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE','UPDATESTOREBASIC']),
      ...mapActions(['getStoreInfo','saveStoreInfo','HotelsEditAlbum']),
      changeStep (step) {
        if (this.add && this.step == 1 && !this.store) return;
        else this.$router.push({name:this.$route.name,query:{...this.$route.query,step}})
      },
      //保存相册
      saveAlbum(info,step){
        this.HotelsEditAlbum({
          type:this.store ?  '' : 'groupAddStore',
          newInfo: info,
          successFun: (id) => {
            let store = this.store || id;
            console.log(info)
            if(info.tabPosition<3){
              step=1
            }
            this.$router.replace({name:this.$route.name,query:{...this.$route.query,store,step}});
            if (this.store) this.UPDATECURRENTSTORE({storeId:this.store});
            this.getStoreInfo();
          }
        })
      },
      //保存信息
      saveBasicInfo(info,step) {
        this.saveStoreInfo({
          type:this.store ?  '' : 'groupAddStore',
          newInfo: info,
          successFun: (id) => {
            let store = this.store || id;
            console.log(info)
            if(info.tabPosition<3){
              step=1
            }
            this.$router.replace({name:this.$route.name,query:{...this.$route.query,store,step}});
            if (this.store) this.UPDATECURRENTSTORE({storeId:this.store});
            this.getStoreInfo();
          }
        })
      }
    }
  }
</script>
